import * as appConfig from './../../app.config';

import { Input, Directive } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { FormEditor } from './../../models/editors/form-editor.base.model';
import { DataUtils } from './../../shared/utils/data-utils';

@Directive()
export class FormEditorBase {
  @Input()
  public field: FormEditor<any>;

  @Input()
  public control: AbstractControl;

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }
}
